import { useState, useEffect, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useMenuConfig } from "../../hooks/useMenuConfig";
import { MenuStatusContext } from "../../context/MenuContext";
import SectionSheet from "../SectionSheet/SectionSheet";
import styles from "./bottomnav.module.css";

export default function BottomNav() {
    const navigate = useNavigate();
    const location = useLocation();
    const { carregando } = useContext(MenuStatusContext);
    const [sectionAberta, setSectionAberta] = useState(null);
    // Realce manual - usado só quando o item clicado NÃO muda o location.pathname
    // pra algo que bata com uma rota de seção (link externo: abre em nova aba,
    // pathname do app não muda nada; conteúdo dinâmico: sempre vai pro mesmo
    // "/menu-conteudo" genérico, não uma rota própria por seção). Sem isso
    // nenhuma seção cujo item seja url/conteúdo consegue ficar destacada.
    const [manualAtiva, setManualAtiva] = useState(null);

    const allSections = useMenuConfig();
    const sections = allSections.filter(s => !!s.nav);

    // Se duas seções tiverem, por engano, um item apontando pra mesma rota
    // (dado configurado errado no Menu do Aplicativo), só a PRIMEIRA que bater
    // fica marcada como ativa - nunca duas ao mesmo tempo.
    // Prefixo, não só igualdade exata (2026-10-14) - sem isso, entrar numa
    // subpágina (ex: /refeicao/almoco, alcançada a partir do item de menu
    // "/refeicao") apagava o destaque da seção, mesmo o colaborador ainda
    // estando dentro dela.
    const secaoPorRota = sections.find(section =>
        section.items.some(item =>
            item.rota && (location.pathname === item.rota || location.pathname.startsWith(item.rota + "/"))
        )
    );

    // Uma navegação de verdade por rota sempre tem prioridade sobre o realce
    // manual - sem isso, destacar "Cultura" ao abrir um link externo ficaria
    // preso lá mesmo depois de navegar por dentro do app pra outra seção.
    useEffect(() => {
        if (secaoPorRota) setManualAtiva(null);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname]);

    function handleSection(section) {
        // seção com 1 item e rota direta: navega sem abrir modal
        if (section.items.length === 1 && section.items[0].rota) {
            setManualAtiva(null);
            const item = section.items[0];
            navigate(item.rota, { state: { titulo: item.label, icone: item.icon, subtitulo: item.subtitulo } });
            return;
        }
        setSectionAberta(section);
    }

    function isActive(section) {
        if (manualAtiva) return section.section === manualAtiva;
        return section === secaoPorRota;
    }

    if (carregando && sections.length === 0) {
        return (
            <div className={styles.container}>
                {[0, 1, 2, 3].map(i => (
                    <div key={i} className={styles.skeletonItem}>
                        <span className={styles.skeletonIcon} />
                        <span className={styles.skeletonLabel} />
                    </div>
                ))}
            </div>
        );
    }

    return (
        <>
            <div className={styles.container}>
                {sections.map((section) => (
                    <div
                        key={section.section}
                        className={`${styles.item} ${isActive(section) ? styles.active : ""}`}
                        onClick={() => handleSection(section)}
                    >
                        <span className={styles.icon}>{section.icon}</span>
                        <span className={styles.label}>{section.shortLabel}</span>
                    </div>
                ))}
            </div>

            {sectionAberta && (
                <SectionSheet
                    section={sectionAberta}
                    onClose={() => setSectionAberta(null)}
                    onItemExterno={() => setManualAtiva(sectionAberta.section)}
                />
            )}
        </>
    );
}
